// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f2a76912","453":"07a6ab98","991":"d0401925"}[chunkId] + ".chunk.js";
};